"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./style.sass");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Tag = function Tag(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    _ref$success = _ref.success,
    success = _ref$success === void 0 ? false : _ref$success,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$inProgress = _ref.inProgress,
    inProgress = _ref$inProgress === void 0 ? false : _ref$inProgress;
  var mainClassName = (0, _classnames.default)('sber-tag', className, {
    'sber-tag--success': success,
    'sber-tag--inProgress': inProgress,
    'sber-tag--disabled': disabled
  });
  return /*#__PURE__*/_react.default.createElement("span", {
    className: mainClassName,
    style: style
  }, children);
};
exports.Tag = Tag;
Tag.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  className: _propTypes.default.string,
  success: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  inProgress: _propTypes.default.bool
};